import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { sections } from '../../../utils/data/shop';
import { useRouter } from 'next/router';

function LivingRoomSection() {
  const router = useRouter();
  const query = router.query;

  return (
    <div className="living-section">
      <h2 className="home-subtitle">Shop BEST Deals for living room</h2>
      <div className="living-wrapper">
        <a
          onClick={() => {
            router.push({
              pathname: '/shop',
              query: {
                ...query,
                filters: JSON.stringify({
                  [sections.categories]: ['Sectionals'],
                  [sections.price]: { min: 0, max: 0 },
                  [sections.materials]: [],
                  [sections.colors]: []
                }),
                sortBy: 'default'
              }
            });
          }}
          className="living-item">
          <LazyLoadImage
            className="living-img"
            src="/images/home/sectionals.jpg"
            width={'255px'}
            alt="Sectionals"
          />
          <span className="living-text">Sectionals</span>
        </a>
        <a
          onClick={() => {
            router.push({
              pathname: '/shop',
              query: {
                ...query,
                filters: JSON.stringify({
                  [sections.categories]: ['Sofas'],
                  [sections.price]: { min: 0, max: 0 },
                  [sections.materials]: [],
                  [sections.colors]: []
                }),
                sortBy: 'default'
              }
            });
          }}
          className="living-item">
          <LazyLoadImage
            className="living-img"
            src="/images/home/sofas.jpg"
            width={'255px'}
            alt="Sofas"
          />
          <span className="living-text">Sofas</span>
        </a>
        <a
          onClick={() => {
            router.push({
              pathname: '/shop',
              query: {
                ...query,
                filters: JSON.stringify({
                  [sections.categories]: ['Loveseats'],
                  [sections.price]: { min: 0, max: 0 },
                  [sections.materials]: [],
                  [sections.colors]: []
                }),
                sortBy: 'default'
              }
            });
          }}
          className="living-item">
          <LazyLoadImage
            className="living-img"
            src="/images/home/loveseats.jpg"
            width={'255px'}
            alt="Loveseats"
          />
          <span className="living-text">Loveseats</span>
        </a>
        <a
          onClick={() => {
            router.push({
              pathname: '/shop',
              query: {
                ...query,
                filters: JSON.stringify({
                  [sections.categories]: ['Ottomans'],
                  [sections.price]: { min: 0, max: 0 },
                  [sections.materials]: [],
                  [sections.colors]: []
                }),
                sortBy: 'default'
              }
            });
          }}
          className="living-item">
          <LazyLoadImage
            className="living-img"
            src="/images/home/ottomans.png"
            width={'255px'}
            alt="Ottomans"
          />
          <span className="living-text">Ottomans</span>
        </a>
      </div>
      <a
        className="living-explore"
        onClick={() => {
          router.push({
            pathname: '/shop',
            query: {
              ...query,
              filters: JSON.stringify({
                [sections.categories]: ['Living Room'],
                [sections.price]: { min: 0, max: 0 },
                [sections.materials]: [],
                [sections.colors]: []
              }),
              sortBy: 'default'
            }
          });
        }}>
        EXPLORE ALL
      </a>
    </div>
  );
}

export default React.memo(LivingRoomSection);
